import { 
  FaGoogle, 
  FaLinux, 
  FaPython, 
  FaDatabase, 
  FaJava, 
  FaShieldAlt, 
  FaMobile, 
  FaChartBar, 
  FaNetworkWired,
  FaTools,
  FaBrain,
  FaCode
} from 'react-icons/fa';

export const certificatesData = [
  // Uniamerica
  {
    id: 1,
    title: 'Smart Data Structures',
    institution: 'Uniamerica',
    category: 'Algoritmos',
    year: '2024',
    icon: <FaBrain />,
    color: '#00d4ff',
    description: 'Certificação em estruturas de dados inteligentes e algoritmos avançados.',
    skills: ['Algoritmos', 'Estruturas de Dados', 'Complexidade', 'Otimização'],
    link: 'https://certificados.descomplica.com.br/graduacao/e6c3b15651a3d665c11e81a336674087b75d4b35e7dc423e9bf4374198dbb79d',
    status: 'completed'
  },
  {
    id: 2,
    title: 'Object-Oriented Dev',
    institution: 'Uniamerica',
    category: 'Programação',
    year: '2024',
    icon: <FaJava />,
    color: '#7c3aed',
    description: 'Certificação em desenvolvimento orientado a objetos.',
    skills: ['POO', 'Java', 'Design Patterns', 'SOLID'],
    link: 'https://certificados.descomplica.com.br/graduacao/1d887ce05d130963038ebc89bb03fb2ba2459acbf4f5a88af3bcaf80cb7dd6f1',
    status: 'completed'
  },
  {
    id: 3,
    title: 'BI & Big Data',
    institution: 'Uniamerica',
    category: 'Dados',
    year: '2024',
    icon: <FaChartBar />,
    color: '#00d4ff',
    description: 'Certificação em Business Intelligence e análise de Big Data.',
    skills: ['Power BI', 'ETL', 'Data Mining', 'Analytics'],
    link: 'https://certificados.descomplica.com.br/graduacao/a56512b0a20e44587018c562c8b729d8661b0651c686602cdf4bea5331690d24',
    status: 'completed'
  },
  {
    id: 4,
    title: 'Mobile Developer',
    institution: 'Uniamerica',
    category: 'Mobile',
    year: '2024',
    icon: <FaMobile />,
    color: '#7c3aed',
    description: 'Certificação em desenvolvimento de aplicações móveis.',
    skills: ['React Native', 'Flutter', 'Android', 'iOS'],
    link: 'https://certificados.descomplica.com.br/graduacao/e56113064ea5b1129d52bc4a1d511f447d9078841269c0abddbf5f07bf7a1a08',
    status: 'completed'
  },
  // Google
  {
    id: 5,
    title: 'Computer Networks',
    institution: 'Google',
    category: 'Redes',
    year: '2023',
    icon: <FaNetworkWired />,
    color: '#00d4ff',
    description: 'Certificação em fundamentos de redes de computadores.',
    skills: ['TCP/IP', 'Redes', 'Protocolos', 'Infraestrutura'],
    link: 'https://www.coursera.org/account/accomplishments/verify/AKXR25K5QAQJ',
    status: 'completed'
  },
  {
    id: 6,
    title: 'Technical Support',
    institution: 'Google',
    category: 'Suporte Técnico',
    year: '2023',
    icon: <FaTools />,
    color: '#7c3aed',
    description: 'Certificação em suporte técnico e troubleshooting.',
    skills: ['Hardware', 'Software', 'Troubleshooting', 'Atendimento'],
    link: 'https://www.coursera.org/account/accomplishments/verify/MQRC35JGMNJS',
    status: 'completed'
  },
  {
    id: 7,
    title: 'Cybersecurity',
    institution: 'Uniamerica',
    category: 'Segurança',
    year: '2023',
    icon: <FaShieldAlt />,
    color: '#00d4ff',
    description: 'Certificação em cibersegurança e proteção de dados.',
    skills: ['Segurança', 'Ethical Hacking', 'Proteção de Dados', 'Auditoria'],
    link: 'https://certificados.descomplica.com.br/graduacao/0e85dfdde3219b9eb700e1cbdc16527598420b8a3e9c3fa8904661989e9976f2',
    status: 'completed'
  },
  {
    id: 8,
    title: 'DB Developer',
    institution: 'Uniamerica',
    category: 'Banco de Dados',
    year: '2024',
    icon: <FaDatabase />,
    color: '#7c3aed',
    description: 'Certificação em desenvolvimento e administração de bancos de dados.',
    skills: ['SQL', 'NoSQL', 'Modelagem', 'Performance'],
    link: 'https://certificados.descomplica.com.br/graduacao/f0b76c6e6135ad56a53967feeaefd7c2312bdc4b6129683f8eb9f3caaa026d0d',
    status: 'completed'
  },
  // Alura
  {
    id: 9,
    title: 'Python Development',
    institution: 'Alura',
    category: 'Programação',
    year: '2022',
    icon: <FaPython />,
    color: '#00d4ff',
    description: 'Certificação em desenvolvimento Python com frameworks modernos. Inclui projetos práticos, APIs REST e integração com bancos de dados.',
    skills: ['Python', 'Flask', 'Django', 'APIs'],
    link: 'https://cursos.alura.com.br/certificate/090d0077-2dde-4bd2-af25-336a897d2846?lang',
    status: 'completed',
    duration: '40h',
    level: 'Intermediário'
  },
  {
    id: 10,
    title: 'Computer Networks',
    institution: 'Alura',
    category: 'Redes',
    year: '2022',
    icon: <FaNetworkWired />,
    color: '#7c3aed',
    description: 'Certificação em redes de computadores e protocolos.',
    skills: ['Redes', 'Segurança', 'Protocolos', 'Administração'],
    link: 'https://cursos.alura.com.br/certificate/ad96b3c9-cc46-44a7-9b9a-bc7259b9a987?lang',
    status: 'completed'
  },
  {
    id: 11,
    title: 'MySQL',
    institution: 'Alura',
    category: 'Banco de Dados',
    year: '2022',
    icon: <FaDatabase />,
    color: '#00d4ff',
    description: 'Certificação em administração e desenvolvimento com MySQL.',
    skills: ['MySQL', 'SQL', 'Modelagem', 'Performance'],
    link: 'https://cursos.alura.com.br/certificate/469cbb89-77b4-4042-af98-b42cf14f6388?lang',
    status: 'completed'
  },
  {
    id: 12,
    title: 'Linux Administration',
    institution: 'Alura',
    category: 'Sistemas',
    year: '2022',
    icon: <FaLinux />,
    color: '#7c3aed',
    description: 'Certificação em administração de sistemas Linux.',
    skills: ['Linux', 'Bash', 'Administração', 'Servidores'],
    link: 'https://cursos.alura.com.br/certificate/5233e3b7-c017-4bf6-9fa1-ae49fc7ee1d1?lang',
    status: 'completed'
  }
];

export const certificateCategories = [
  { id: 'all', label: 'Todos' },
  { id: 'Programação', label: 'Programação' },
  { id: 'Redes', label: 'Redes' },
  { id: 'Banco de Dados', label: 'Banco de Dados' },
  { id: 'Sistemas', label: 'Sistemas' },
  { id: 'Segurança', label: 'Segurança' },
  { id: 'Mobile', label: 'Mobile' },
  { id: 'Dados', label: 'Dados' },
  { id: 'Suporte Técnico', label: 'Suporte' },
  { id: 'Algoritmos', label: 'Algoritmos' }
];

export const institutionCategories = [
  { id: 'Uniamerica', label: 'Uniamerica' },
  { id: 'Google', label: 'Google' },
  { id: 'Alura', label: 'Alura' }
];

export const getCertificatesByCategory = (category) => {
  if (category === 'all') return certificatesData;
  return certificatesData.filter(cert => cert.category === category);
};

export const getCertificatesByInstitution = (institution) => {
  return certificatesData.filter(cert => cert.institution === institution);
};

export const institutions = [
  { name: 'Uniamerica', count: getCertificatesByInstitution('Uniamerica').length },
  { name: 'Google', count: getCertificatesByInstitution('Google').length },
  { name: 'Alura', count: getCertificatesByInstitution('Alura').length }
];